import numeral from 'numeral';

export const formatNumber = (amount: number): string =>
  amount.toLocaleString(undefined, {
    maximumFractionDigits: 2,
  });

export const formatAmount = (amount: number | string, short = false): string => {
  const float = typeof amount === 'string' ? parseFloat(amount) : amount;
  return numeral(float.toFixed(5)).format(short ? '0,0' : '0,0.00');
};
